import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_OLOREQUEST_OF } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolOloRequestOFState extends EntityState<IID_OL_OLOREQUEST_OF, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_OLO_REQUEST_OF , realtimeEntity: 'IID_OL_OloRequestOF'})
@InterfaceDataStore(InterfaceName.OLO_REQUEST_OF)
export class IIDolOloRequestOFStore extends EntityStore<IIDolOloRequestOFState> {
  constructor() {
    super([]);
  }
}
